import { useSlots, inject, computed, onMounted, openBlock, createBlock, createSlots, withCtx, createVNode, renderSlot } from "vue";
import { DropdownContextKey } from "../Symbols.mjs";
import FhDropdownBaseItem from "../FhDropdownBaseItem/FhDropdownBaseItem.mjs";
import FhRadioInput from "../../Forms/FhRadioInput/FhRadioInput.mjs";
const _sfc_main = {
  __name: "FhDropdownSingleSelectItem",
  props: {
    prefixIcon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  setup(__props) {
    const slots = useSlots();
    const props = __props;
    const dropdownContext = inject(DropdownContextKey, void 0);
    const radioGroupContext = inject("radioGroupContext", void 0);
    const computedSelected = computed(
      () => {
        var _a;
        return ((_a = radioGroupContext == null ? void 0 : radioGroupContext.groupValue) == null ? void 0 : _a.value) === props.value;
      }
    );
    const handleSelect = (event) => {
      var _a;
      dropdownContext == null ? void 0 : dropdownContext.selected(event);
      (_a = radioGroupContext == null ? void 0 : radioGroupContext.handleChange) == null ? void 0 : _a.call(radioGroupContext, props.value);
    };
    onMounted(() => {
      if (!slots.default || slots.default().length === 0) {
        console.warn("FhDropdownItem component requires default slot content.");
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhDropdownBaseItem, {
        prefixIcon: props.prefixIcon,
        disabled: props.disabled,
        "aria-selected": computedSelected.value,
        selected: computedSelected.value,
        onSelect: handleSelect
      }, createSlots({
        input: withCtx(() => [
          createVNode(FhRadioInput, {
            valid: "",
            hidden: "",
            value: props.value,
            checked: computedSelected.value,
            tabindex: "-1"
          }, null, 8, ["value", "checked"])
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        _ctx.$slots["description-inline"] ? {
          name: "description-inline",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "description-inline")
          ]),
          key: "0"
        } : void 0,
        _ctx.$slots["description-block"] ? {
          name: "description-block",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "description-block")
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["prefixIcon", "disabled", "aria-selected", "selected"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=FhDropdownSingleSelectItem.mjs.map
